function toggleCommunityFilterDrawer(event) {
	if (dragging) return;

	var target = event.target.closest("#communities-filter-sort .filter-bar .toggle-filter-drawer, #communities-filter-sort .filter-bar .filter-drawer .close");
	if (target) {
		event.preventDefault();

		document.querySelector("#communities-filter-sort .filter-bar .filter-drawer").classList.toggle("active");
	}
}

function submitCommunityFilterForm(event) {
	if (dragging) return;

	var target = event.target.closest("#communities-filter-sort .update");
	if (target) {
		var filterForm = document.getElementById("communities-filter-sort");

		var fields = filterForm.querySelectorAll("select");
		for (var i = 0; i < fields.length; i++) {
			var field = fields[i],
				fieldLabel = fields[i].closest("label");

			if (fieldLabel !== null & window.getComputedStyle(fieldLabel).display == 'none') {
				field.disabled = true;
			}
		}

		var fields = filterForm.querySelectorAll("input[type=checkbox]");
		for (var i = 0; i < fields.length; i++) {
			var field = fields[i],
				fieldLabel = fields[i].closest("fieldset");

			if (fieldLabel !== null & window.getComputedStyle(fieldLabel).display == 'none') {
				field.disabled = true;
			}
		}

		filterForm.submit();
	}
}

function updateCommunityFilterResults(event) {
	if (dragging) return;

	var target = event.target.closest("#communities-filter-sort select");
	if (target) {
		var filterForm = document.getElementById("communities-filter-sort");

		var fields = filterForm.querySelectorAll("select");
		for (var i = 0; i < fields.length; i++) {
			var field = fields[i],
				fieldLabel = fields[i].closest("label");

			if (fieldLabel !== null & window.getComputedStyle(fieldLabel).display == 'none') {
				field.disabled = true;
			}
		}

		var fields = filterForm.querySelectorAll("input[type=checkbox]");
		for (var i = 0; i < fields.length; i++) {
			var field = fields[i],
				fieldLabel = fields[i].closest("fieldset");

			if (fieldLabel !== null & window.getComputedStyle(fieldLabel).display == 'none') {
				field.disabled = true;
			}
		}

		filterForm.submit();
	}
}

function updateCommunitiesResultsView(event) {
	if (dragging) return;

	var target = event.target.closest("#communities-filter-sort .results-sort-view .view a");
	if (target) {
		event.preventDefault();

		var viewOptions = document.querySelectorAll("#communities-filter-sort .results-sort-view .view a");
		for (var i = 0; i < viewOptions.length; i++) {
			if (viewOptions[i].classList.contains("active")) {
				viewOptions[i].classList.remove("active");
				document.querySelector(".communities-listing[data-view=" + viewOptions[i].getAttribute("data-view") + "]").classList.remove("active");
			}
		}

		target.classList.add("active");
		document.querySelector(".communities-listing[data-view=" + target.getAttribute("data-view") + "]").classList.add("active");
	}
}

document.addEventListener("click", toggleCommunityFilterDrawer);
document.addEventListener("touchend", toggleCommunityFilterDrawer);

document.addEventListener("click", updateCommunitiesResultsView);
document.addEventListener("touchend", updateCommunitiesResultsView);

document.addEventListener("click", submitCommunityFilterForm);

document.addEventListener("change", updateCommunityFilterResults);